import { render, staticRenderFns } from "./GeneralAgentEnrollment.vue?vue&type=template&id=b47ef506&scoped=true&"
import script from "./GeneralAgentEnrollment.vue?vue&type=script&lang=js&"
export * from "./GeneralAgentEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./GeneralAgentEnrollment.vue?vue&type=style&index=0&id=b47ef506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47ef506",
  null
  
)

export default component.exports